import React from 'react'
import CareerDetails from '../CareerDetails'
import jobList from './positionList.json'

const FrontendDeveloper = () => {
  return <CareerDetails {...jobList[5]} />
}

export default FrontendDeveloper
